import React from 'react';
import styled from 'styled-components';
import { theme, Text, ButtonAnt } from '@pfmam/pfmam';
import { Box } from '../../styles/globalStyle';
import { ArrowRightOutlined } from '@ant-design/icons';

const ChangeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid ${theme.colors.grey};
  gap: 12px;
  &:last-of-type {
    border-bottom: 0;
  }
`;

const LabelCol = styled.div`
  min-width: 150px;
  max-width: 150px;
`;

const ValueCol = styled.div`
  flex: 1;
  text-align: right;
`;

const ArrowCol = styled.div`
  color: ${theme.colors.grey_tertiary};
  font-size: 14px;
  flex-shrink: 0;
`;

const OldValue = styled.span`
  color: ${theme.colors.grey_tertiary};
  text-decoration: line-through;
  font-size: ${theme.font_size.size_xl};
`;

const NewValue = styled.span`
  color: ${theme.colors.clean_black};
  font-weight: 600;
  font-size: ${theme.font_size.size_xl};
`;

const ConfirmButton = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
    transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
      transform: translateY(-1px);
      filter: brightness(0.93);
    }
    &:active {
      transform: translateY(0);
      box-shadow: none;
      filter: brightness(0.85);
    }
  }
`;

const ThirdPartyHoldingsReviewModal = ({ changes, onConfirm, onBack, primaryColor, submitting, submitError }) => {
  return (
    <>
      <Text
        label="Please review your changes before submitting."
        color={`${theme.colors.black_tertiary}`}
        fontSize={`${theme.font_size.size_xl}`}
        lineheight="24px"
        padding="0 0 20px 0"
      />

      {changes.map(({ label, originalValue, newValue }) => (
        <ChangeRow key={label}>
          <LabelCol>
            <Text
              label={label}
              color={`${theme.colors.black_secondary}`}
              fontSize={`${theme.font_size.size_xl}`}
              lineheight="20px"
            />
          </LabelCol>
          <ValueCol>
            <OldValue>{originalValue || '—'}</OldValue>
          </ValueCol>
          <ArrowCol>
            <ArrowRightOutlined />
          </ArrowCol>
          <ValueCol>
            <NewValue>{newValue || '—'}</NewValue>
          </ValueCol>
        </ChangeRow>
      ))}

      <Box display="flex" justifycontent="space-between" margin="32px 0 0 0">
        {submitError && (
          <Text
            label={submitError}
            color={`${theme.colors.danger_red}`}
            fontSize={`${theme.font_size.size_l}`}
            lineheight="20px"
            padding="0 0 12px 0"
          />
        )}
        <Box display="flex" justifycontent="space-between" width="100%">
          <ButtonAnt
            type="secondary"
            label="Go Back"
            onClick={onBack}
            disabled={submitting}
            style={{ minWidth: '120px' }}
          />
          <ConfirmButton
            type="primary"
            linkTextColor={primaryColor}
            label={submitting ? 'Saving...' : 'Confirm & Submit'}
            onClick={onConfirm}
            disabled={submitting}
            style={{ minWidth: '148px' }}
          />
        </Box>
      </Box>
    </>
  );
};

export default ThirdPartyHoldingsReviewModal;
